import FactoryComponents from '../../../../../factory/components/FactoryComponents.js';
import ProcessWorkGovernChoose from '../processDangerGovern/ProcessWorkGovernChoose.vue';
import {getRiskCtrlList, listRiskCtrl} from "@/api/doublePrevention/riskCtrl";
import { listRiskObject } from "@/api/doublePrevention/riskObject";
import { downLoadNewument } from "@/api/downLoad"

const root = {}
export default root
root.components = { ProcessWorkGovernChoose };
root.name = 'processDangerGovern';
root.data = {
    //当前界面模式，1:代表当前是table显示信息界面，0代表新建或编辑界面
    thisOperaModel: 1,

    //当前用户id
    thisUserId: -1,

    //当前企业
    thisDBname: '',

    dangerGovernTableTitle: [
        {
            title: '编号',
            slot: 'num',
            width: 150,
            // fixed: 'left'
        },
        {
            title: '状态',
            slot: 'status',
            width: 100,
        },
        {
            title: '隐患名称',
            slot: 'hdName',
            width: 100,
        },
        {
            title: '隐患级别',
            // key: 'level',
            slot: 'level',
            width: 110,
        },
        {
            title: '检查时间',
            slot: 'checkTime',
            // tooltip: true
            // width: 180,
        },
        {
            title: '计划整改时间',
            slot: 'planRectificationTime',
            // tooltip: true
            // width: 180,
        },
        {
            title: '应急预案',
            slot: 'planManagementVos',
            // width: 250,
        },
        {
            title: '创建人',
            slot: 'createUser',
            width: 80,
        },
        {
            title: '检查部位',
            key: 'checkParts',
            width: 100,
        },
        {
            title: '来源',
            key: 'originate',
            // width: 100,
        },
        {
            title: '整改人',
            slot: 'rectifierVo',
            width: 80,
        },
        {
            title: '隐患整改资金',
            slot: 'approveInfoVo',
            // width: 200,
        },
        {
            title: '存在问题和隐患',
            key: 'problem',
            // width: 200,
        },
        {
            title: '操作',
            slot: 'action',
            // width: 150,
            // fixed: 'right',
        }
    ],
    dangerGovernTableTitle1: [
        {
            title: '编号',
            slot: 'num',
            width: 150,
            // fixed: 'left'
        },
        {
            title: '状态',
            slot: 'status',
            width: 100,
        },
        {
            title: '隐患名称',
            slot: 'hdName',
            width: 100,
        },
        {
            title: '隐患级别',
            // key: 'level',
            slot: 'level',
            width: 110,
        },
        {
            title: '检查时间',
            slot: 'checkTime',
            // tooltip: true
            // width: 180,
        },
        {
            title: '计划整改时间',
            slot: 'planRectificationTime',
            // tooltip: true
            // width: 180,
        },
        {
            title: '应急预案',
            slot: 'planManagementVos',
            // width: 250,
        },
        {
            title: '创建人',
            slot: 'createUser',
            width: 80,
        },
        {
            title: '检查部位',
            key: 'checkParts',
            width: 100,
        },
        {
            title: '来源',
            key: 'originate',
            // width: 100,
        },
        {
            title: '整改人',
            slot: 'rectifierVo',
            width: 80,
        },
        {
            title: '隐患整改资金',
            slot: 'approveInfoVo',
        },
        {
            title: '存在问题和隐患',
            key: 'problem',
            // width: 200,
        },
        {
            title: '数据状态',
            slot: 'isDel',
            // width: 150,
            // fixed: 'right',
        },
        {
            title: '操作',
            slot: 'action',
            // width: 150,
            // fixed: 'right',
        }
    ],
    dangerGovernData: {
        //模糊查询条件
        selectCondition: {
            searchParam: '',
            status: 100,
            checkStartTime: '',
            checkEndTime: '',
        },
        //总页数
        total: 1,
        //每页多少行
        limit: 10,
        //当前页数
        thisPage: 1,
        //数据
        data: [],

        dangerTaskData: [],
        //当前操作数据
        thisOperaData: {
            //隐患操作缓存数据
            cacheData: {
                annexFileDto: []
            },
            http: null,
            showOpera: false,
            //点击操作后流程
            processIndex: 0,
            //是否是查看模式
            seeModel: false,


        },

        //隐患级别
        dangerGovernLevel: [
            {
                value: 0,
                name: '一般隐患'
            },
            {
                value: 1,
                name: '重大隐患'
            }
        ],
        //隐患类别
        chooseHiddenDangerData: [],
        //风险管控措施
        ctrlData: [],
        //风险分析对象
        riskObjectData: [],
        hdType: [
            {
                value: 'X100101',
                name: '资质证照'
            },
            {
                value: 'X100102',
                name: '安全生产管理机构及人员'
            },
            {
                value: 'X100103',
                name: '安全规章制度'
            },
            {
                value: 'X100104',
                name: '安全培训教育'
            },
            {
                value: 'X100105',
                name: '安全投入'
            },
            {
                value: 'X100106',
                name: '相关方面管理'
            },
            {
                value: 'X100107',
                name: '重大危险源管理'
            },
            {
                value: 'X100108',
                name: '个体防护装备'
            },
            {
                value: 'X100109',
                name: '职业健康'
            },
            {
                value: 'X100110',
                name: '应急管理'
            },
            {
                value: 'X100111',
                name: '隐患排查治理'
            },
            {
                value: 'X100112',
                name: '事故报告、调查和处理'
            },
            {
                value: 'X100113',
                name: '其他基础管理'
            },
            {
                value: 'X100201',
                name: '作业场所'
            },
            {
                value: 'X100202',
                name: '设备设施'
            },
            {
                value: 'X100203',
                name: '防护、保险、信号等装置装备'
            },
            {
                value: 'X100204',
                name: '原辅物料、产品'
            },
            {
                value: 'X100205',
                name: '职业病危害'
            },
            {
                value: 'X100206',
                name: '相关方作业'
            },
            {
                value: 'X100207',
                name: '安全技能'
            },
            {
                value: 'X100208',
                name: '个体防护'
            },
            {
                value: 'X100209',
                name: '作业许可'
            },
            {
                value: 'X100210',
                name: '其他现场管理'
            },
        ],
        checkType: [
            {
                value: 'HTG07',
                name: '日常排查'
            },
            {
                value: 'HTG08',
                name: '综合性排查'
            },
            {
                value: 'HTG09',
                name: '专业性排查'
            },
            {
                value: 'HTG10',
                name: '季节性排查'
            },
            {
                value: 'HTG04',
                name: '重点时段及节假日前排查'
            },
            {
                value: 'HTG11',
                name: '事故类比排查'
            },
            {
                value: 'HTG12',
                name: '复产复工前排查'
            },
            {
                value: 'HTG06',
                name: '外聘专家诊断式排查 '
            },
            {
                value: 'HTG13',
                name: '管控措施失效'
            },
            {
                value: 'HTG99',
                name: '其他'
            },
        ],
        neateType: [
            {
                value: 'X2401',
                name: '立即整改'
            },
            {
                value: 'X2402',
                name: '限期整改'
            }
        ],
        neatenSituation: [
            {
                value: 'X1301',
                name: '未整改'
            },
            {
                value: 'X1303',
                name: '已整改'
            }
        ],
        //人员数据
        employeeDatas: [],

        //应急预案数据
        planManagementDatas: [],
        //部门数据
        deptDatas: [],

    },

    // 默认显示的已上传的文件
    defaultList: [],
    fileArr: [], // 保存已上传的文件

    buildingPic: '',
    buildingAfterPic: '',
}

root.methods = {

    getCtrlList: function () {
        getRiskCtrlList().then(res => {
            const that = this;
            that.dangerGovernData.ctrlData = res.body.data
        })
    },
    getriskObjectList: function () {
        listRiskObject().then(res => {
            const that = this;
            that.dangerGovernData.riskObjectData = res.body.data
        })
    },

    getTaskList: function () {
        if (this.dangerGovernData.dangerTaskData.length === 0) {
            const that = this;
            const data = {};
            data.name = "";
            data.curPage = 1;
            data.limit = 1000;
            this.componentsMoudel.startPost(this.componentsMoudel.getData('urls').getDangerTaskListAll, data, true).then(res => {
                that.dangerGovernData.dangerTaskData = res.body.data === null ? [] : res.body.data;
            })
        }
    },
    excelImportSuccess: function () {
        this.$refs.userExcel.clearFiles();
        this.getDangerGovern(1);
    },

    // 新增或编辑的时候上传治理图片的事件
    handleAvatarSuccess1(res, file) {
        this.buildingPic = file.response.data
    },
    // 新增或编辑的时候上传治理图片的事件
    handleAvatarSuccess2(res, file) {
        // console.log(file)
        this.buildingAfterPic = file.response.data
    },
    //获取隐患治理
    getDangerGovern: function (page) {
        this.dangerGovernData.thisPage = page
        const that = this;
        const data = {};
        data.searchParam = this.dangerGovernData.selectCondition.searchParam;
        data.curPage = page;
        data.limit = this.dangerGovernData.limit;
        if (this.dangerGovernData.selectCondition.status !== 100) {
            data.status = this.dangerGovernData.selectCondition.status;
        }
        if (this.dangerGovernData.selectCondition.checkStartTime !== '') {
            data.checkStartTime = this.dangerGovernData.selectCondition.checkStartTime;
        }
        if (this.dangerGovernData.selectCondition.checkEndTime !== '') {
            data.checkEndTime = this.dangerGovernData.selectCondition.checkEndTime;
        }
        this.componentsMoudel.startPost('/hiddenGovern/list_all', data, true).then(res => {
            that.dangerGovernData.data = res.body.data === null ? [] : res.body.data;
            that.dangerGovernData.total = res.body.cum;
            // that.dangerGovernData.thisPage = res.body.page;
        })
    },
    //上报管委平台
    identificationBtn: function (data) {
        const that = this;
        this.componentsMoudel.startPost('/hiddenGovern/upload/' + data.id, data, true).then(res => {
            if (this.dangerGovernData.data.length <= 1 && this.dangerGovernData.thisPage > 1) {
                this.dangerGovernData.thisPage -= 1
            }
            that.getDangerGovern(that.dangerGovernData.thisPage);
            this.$message.success('上报成功')
        })
    },
    //删除隐患治理
    delDangerGovern: function (data) {
        const that = this;
        this.componentsMoudel.startPost('/hiddenGovern/delete/' + data.id, data, true).then(res => {
            if (this.dangerGovernData.data.length <= 1 && this.dangerGovernData.thisPage > 1) {
                this.dangerGovernData.thisPage -= 1
            }
            that.getDangerGovern(that.dangerGovernData.thisPage);
            this.$message.success('删除成功')
        })
    },
    uploadDangerGovern: function (data) {
        const that = this;
        this.componentsMoudel.startPost('/hiddenGovern/upload/' + data.id, data, true).then(res => {
            if (this.dangerGovernData.data.length <= 1 && this.dangerGovernData.thisPage > 1) {
                this.dangerGovernData.thisPage -= 1
            }
            that.getDangerGovern(that.dangerGovernData.thisPage);
            this.$message.success('上报成功')
        })
    },
    //更新隐患治理
    updateDangerGovern: function () {
        const that = this;
        const isRisk = this.dangerGovernData.thisOperaData.cacheData.isRisk === '否' ? 0 : 1;
        //将隐患类别和应急预案的数组转为字符串
        const riskType = JSON.stringify(this.dangerGovernData.thisOperaData.cacheData.riskType)
        const planId = JSON.stringify(this.dangerGovernData.thisOperaData.cacheData.planId)

        const data = {
            ...this.dangerGovernData.thisOperaData.cacheData,
            isRisk,
            riskType,
            planId,
            buildingPic: this.buildingPic,
            //buildingAfterPic: this.buildingAfterPic
        };
        if (this.$route.params.originate) {
            data.originate = this.$route.params.originate
        }
        this.componentsMoudel.startPost('/hiddenGovern/update', data, true).then(res => {
            that.getDangerGovern(that.dangerGovernData.thisPage);
            that.returnTableDangerGovern();
        })
    },

    //新增隐患治理
    addDangerGovern: function () {
        if (!this.dangerGovernData.thisOperaData.cacheData.approverId) {
            this.$message({
                message: '请选择审批人',
                type: 'error'
            });
            return;
        }
        if (!this.dangerGovernData.thisOperaData.cacheData.rectifierId) {
            this.$message({
                message: '请选择整改人',
                type: 'error'
            });
            return;
        }
        if (!this.dangerGovernData.thisOperaData.cacheData.reviewerId) {
            this.$message({
                message: '请选择复查人',
                type: 'error'
            });
            return;
        }
        const that = this;
        const isRisk = this.dangerGovernData.thisOperaData.cacheData.isRisk === '否' ? 0 : 1;
        const riskType = JSON.stringify(this.dangerGovernData.thisOperaData.cacheData.riskType)
        const planId = JSON.stringify(this.dangerGovernData.thisOperaData.cacheData.planId)
        const hdId = this.dangerGovernData.thisOperaData.cacheData.hdId
        const ctrlId = this.dangerGovernData.thisOperaData.cacheData.ctrlId
        const riskObjectId = this.dangerGovernData.thisOperaData.cacheData.riskObjectId
        const isTest = this.dangerGovernData.thisOperaData.cacheData.isTest;
        const data = {
            ...this.dangerGovernData.thisOperaData.cacheData,
            isRisk,
            riskType,
            planId,
            buildingPic: this.buildingPic,
            // buildingAfterPic: this.buildingAfterPic,
            hdId,
            ctrlId,
            riskObjectId,
            isTest
        };
        if (this.$route.params.originate) {
            data.originate = this.$route.params.originate
        }
        this.componentsMoudel.startPost('/hiddenGovern/save', data, true).then(res => {
            that.getDangerGovern(that.dangerGovernData.thisPage);
            that.returnTableDangerGovern();
        })
    },
    exportExcel: function () {
        // this.componentsMoudel.startGet('/hiddenGovern/exportExcel')
        downLoadNewument('/hiddenGovern/exportExcel', '隐患治理台账_' + (new Date().getTime()) + '_.xlsx')
    },
    //点击新增或编辑时的操作
    operaDangerGovern: function (data, see) {
        if (data) {
            const isRisk = data.isRisk === 0 ? '否' : '是';
            let planId = [];
            if (data.planId) {
                planId = JSON.parse(data.planId)
            }
            let riskType = [];
            if (data.riskType) {
                riskType = JSON.parse(data.riskType)
            }
            this.dangerGovernData.thisOperaData.cacheData = {
                ...data,
                isRisk,
                planId,
                riskType
            };
            this.dangerGovernData.thisOperaData.cacheData.annexFileDto = []
            if (data.annexFile) {
                this.defaultList = []
                let arr2 = JSON.parse(data.annexFile)
                for (let i in arr2) {
                    this.defaultList.push({
                        name: arr2[i].fileName,
                        url: arr2[i].url
                    })
                }
                this.dangerGovernData.thisOperaData.cacheData.annexFileDto = this.arr2
            }
            this.buildingPic = data.buildingPic
            this.buildingAfterPic = data.buildingAfterPic
            this.dangerGovernData.thisOperaData.http = this.updateDangerGovern;
        } else {
            this.dangerGovernData.thisOperaData.cacheData = {
                isRisk: '否',
                level: 0,
                planId: [],
                riskType: [],
                annexFileDto: [],
            }
            this.dangerGovernData.thisOperaData.http = this.addDangerGovern;
            see = false;
        }
        this.dangerGovernData.thisOperaData.seeModel = see;
        this.thisOperaModel = 0;
        this.getAllHiddenDanger();
        this.getAllEployee();
        this.getPlanManagement();
        this.getTaskList();
        this.getCtrlList();
        this.getriskObjectList();
    },

    //返回到表格数据显示界面
    returnTableDangerGovern: function () {
        this.dangerGovernData.thisOperaData.cacheData = {};
        this.thisOperaModel = 1;
    },

    //获取隐患列表
    getAllHiddenDanger: function () {
        const that = this;
        this.componentsMoudel.startGet(this.componentsMoudel.getData('urls').getDangerTypeAll).then(res => {
            const data = [];
            //获取到隐患类别后，对iview的Cascader组件所需的数据进行处理
            res.body.data.forEach((item, index) => {
                const dataChild = that.hiddenDangerDataInit(item);
                data.push(dataChild);
            })
            that.dangerGovernData.chooseHiddenDangerData = data;
        })

    },
    //隐患类别Cascader数据配置
    hiddenDangerDataInit: function (data) {
        const newData = {
            children: []
        };
        if (data.childs.length > 0) {
            data.childs.forEach((item, index) => {
                const dataChild = this.hiddenDangerDataInit(item);
                newData.children.push(dataChild);
            });
        }
        newData.value = data.id;
        newData.label = data.name;
        return newData;
    },

    //获取人员列表
    getAllEployee: function () {
        if (this.dangerGovernData.employeeDatas.length === 0) {
            const that = this;
            const data = {};
            data.curPage = 1;
            data.limit = 1000;
            this.componentsMoudel.startGet(this.componentsMoudel.getData('urls').getAllUser, data, false).then(res => {
                that.dangerGovernData.employeeDatas = res.body.data;
            })
        }
    },

    //获取应急管理数据
    getPlanManagement: function () {
        const that = this;
        const data = {};
        data.curPage = 1;
        data.limit = 1000;
        this.componentsMoudel.startPost('/planManagement/list_all', data, false).then(res => {
            that.dangerGovernData.planManagementDatas = res.body.data;
        })
    },

    //获取当前用户id
    getUserData: function () {
        const that = this;
        this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').userInfo)
            .startGet().then((res) => {
                this.dangerGovernData.thisOperaData.cacheData.creatorId = res.body.data.id;
                this.thisUserId = res.body.data.id;
            });
    },

    // 限制文件只能上传一个
    //   handleBeforeUpload () {
    //     const check = this.fileArr.length < 1;
    //     if (!check) {
    //         this.$message.warning('只能上传一个文件,若要上传请先删除列表中的文件')
    //     }
    //     return check;
    // },

    //文件上传成功
    fileUploadSuccess: function (response, file, fileList) {
        this.fileArr.push({ fileName: file.name, url: file.response.data })
        this.dangerGovernData.thisOperaData.cacheData.annexFileDto = this.fileArr
        // this.dangerGovernData.thisOperaData.cacheData.annexFileDto.push({fileName: file.name,url: file.response.data})
    },

    //文件移除
    fileRemove: function (file, fileList) {
        for (let i in this.fileArr) {
            if (this.fileArr[i].url == file.url) {
                this.fileArr.splice(i, 1)
            }
        }
        this.dangerGovernData.thisOperaData.cacheData.annexFileDto = this.fileArr
    },

    //点击表格的操作
    operaStatus: async function (data) {
        const res = await this.componentsMoudel.startGet('/hiddenGovern/info/' + data.id, null, false);
        this.dangerGovernData.thisOperaData.showOpera = true;
        data = { ...data, ...res.body.data };
        if (!data.approverVo) {
            data.approverVo = {};
        }
        this.dangerGovernData.thisOperaData.processIndex = data.status;
        if (data) {
            const isRisk = data.isRisk === 0 ? '否' : '是';
            let planId = [];
            if (data.planId) {
                planId = JSON.parse(data.planId)
            }
            let riskType = [];
            if (data.riskType) {
                riskType = JSON.parse(data.riskType)
            }
            this.dangerGovernData.thisOperaData.cacheData = {
                ...data,
                isRisk,
                planId,
                riskType
            };
            this.getDeptData();
            this.getAllEployee();
        }
    },
    operaStatusQuery: async function (data) {
        // console.log(data);
        const res = await this.componentsMoudel.startGet('/hiddenGovern/infoForNum/' + data.hiddenGovernNum, null, false);
        this.dangerGovernData.thisOperaData.showOpera = true;
        data = res.body.data;
        this.dangerGovernData.thisOperaData.processIndex = data.status;
        if (res) {
            const isRisk = data.isRisk === 0 ? '否' : '是';
            let planId = [];
            if (data.planId) {
                planId = JSON.parse(data.planId)
            }
            let riskType = [];
            if (data.riskType) {
                riskType = JSON.parse(data.riskType)
            }
            this.dangerGovernData.thisOperaData.cacheData = {
                ...data,
                isRisk,
                planId,
                riskType
            };
            this.getDeptData();
            this.getAllEployee();
        }
    },
    // 关闭抽屉
    closeOpera: function () {
        this.dangerGovernData.thisOperaData.showOpera = false;
        // return false
    },

    //获取部门
    getDeptData: function () {
        if (this.dangerGovernData.deptDatas.length === 0) {
            const that = this;
            let data = {};
            data.curPage = 1;
            data.limit = 1000;
            // this.componentsMoudel.startPost('/emploteedepartment/list_all', data, false).then(res => {
            this.componentsMoudel.startGet('/businessManagement/departmentManagement/getAll', data, false).then(res => {
                that.dangerGovernData.deptDatas = res.body.data;
            })
        }
    },

    childOperaSuccess: function (data, index) {
        this.getDangerGovern(this.dangerGovernData.thisPage);
        this.operaStatus(data);
        this.dangerGovernData.thisOperaData.processIndex = index;
    }

}
root.created = function () {
    // 从其它页面跳转过来添加隐患治理
    if (this.$route.params.jumpStatus) {
        this.dangerGovernData.thisOperaData.cacheData = {
            isRisk: '否',
            level: 0,
            planId: [],
            riskType: [],
            annexFileDto: [],
        }
        this.dangerGovernData.thisOperaData.http = this.addDangerGovern;
        this.dangerGovernData.thisOperaData.seeModel = false;
        this.thisOperaModel = 0;
        if (this.$route.params.examination) {
            this.dangerGovernData.thisOperaData.cacheData.checkParts = this.$route.params.examination
        }
        if (this.$route.params.hiddenDanger) {
            this.dangerGovernData.thisOperaData.cacheData.problem = this.$route.params.hiddenDanger
        }
        this.getAllHiddenDanger();
        this.getAllEployee();
        this.getPlanManagement();
    }
}
root.mounted = function () {
    this.thisDBname = localStorage.getItem('manufacturer')
    if (this.thisDBname === "wuweiyiti237" || this.thisDBname === "wuweiyiti240" || this.thisDBname === "wuweiyiti257" || this.thisDBname === "wuweiyiti249"|| this.thisDBname === "wuweiyiti250") {
        this.dangerGovernTableTitle = this.dangerGovernTableTitle1
    }
    this.getUserData();
    this.getDangerGovern(1);
    this.$nextTick(function () {
        if (this.$route.query.hiddenGovernNum) {
            this.operaStatusQuery(this.$route.query);
        } else if (this.$route.query.id) {
            this.operaStatus(this.$route.query);
        }
    });
}

FactoryComponents.initComponent(root);
